"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconsReact = require("@carbon/icons-react");

require("./sass/modal.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Modal = function Modal(_ref) {
  var title = _ref.title,
      children = _ref.children,
      isVisible = _ref.isVisible,
      onClose = _ref.onClose,
      className = _ref.className,
      zIndex = _ref.zIndex,
      classNameContent = _ref.classNameContent;

  var escKeyFunction = function escKeyFunction(event) {
    if (event.keyCode === 27) {
      onClose();
    }
  };

  var modalRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (isVisible) {
      document.body.classList.add('bodyFixed');
      document.addEventListener('keydown', escKeyFunction);
      return function () {
        document.body.classList.remove('bodyFixed');
        document.removeEventListener('keydown', escKeyFunction);
      };
    }
  }, [isVisible]);

  if (isVisible) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "schola-modal ".concat(className),
      style: {
        zIndex: zIndex
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: !onClose && !title ? 'schola-modal-child' : 'schola-modal-child',
      ref: modalRef
    }, onClose || title ? /*#__PURE__*/_react.default.createElement("div", {
      className: title ? 'schola-modal-child-header' : 'schola-modal-child-header flexend'
    }, title && /*#__PURE__*/_react.default.createElement("h3", {
      className: "schola-modal-child-close-header-title"
    }, title), onClose && /*#__PURE__*/_react.default.createElement(_iconsReact.Close32, {
      fill: "#96A3B8",
      className: "schola-modal-child-header-icon cursor-pointer",
      onClick: onClose
    })) : null, /*#__PURE__*/_react.default.createElement("div", {
      className: "schola-modal-child-content ".concat(classNameContent)
    }, children)));
  } else {
    return null;
  }
};

Modal.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  isVisible: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
};
Modal.defaultProps = {
  title: null,
  children: 'Displaying modal content',
  isVisible: false,
  onClose: null,
  className: null
};
var _default = Modal;
exports.default = _default;